// tooltipText.js
export const TOOLTIP_VALUES = {
  rewardPayment:
    'Answers must be completed in full. Context and quality of the answers will be checked and verified for completion. Please allow up to 7 to 14 days to receive the gift card reward. One reward per user. We will provide an email explanation if the survey completion did not meet the requirements to allow you to re-submit your answers. Limited time offer and limited to first 30 entrants!',

  warranty: 'Warranty details may vary based on the dealer and model.',

  securityNotice: [
    'Keep your password private.',
    'Never share login details over email.',
    'We use encryption to protect your data.',
  ],

  htmlExample: (
    <>
      <strong>Note:</strong> This is a <em>custom</em> <u>HTML block</u>.
    </>
  ),
};

export const TOOLTIP_TYPES = {
  estimatedPayment: 'text',
  warranty: 'text',
  securityNotice: 'list',
  htmlExample: 'html',
};
